import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/core/services/base.service';
import { Observable } from 'rxjs';
import { IResponse } from 'src/app/shared/models/app';
import * as moment from 'moment';
import { map } from 'rxjs/operators';
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';
import { SessionStorageService } from 'ngx-webstorage';
import { CacheConstant } from 'src/app/core/cache/cache.constant';

@Injectable({

  providedIn: 'root'

})

export class InventoryService extends BaseService {


  constructor(protected http: HttpClient, private storage: SessionStorageService,
    private cache:CacheResolverService) {
    super(http);
  }

  getTasks(): Observable<any> {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.hp + '/api/tasks?');
    return super.fetch(url);
  }

  getVendorsList() {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.util + '/api/vendors?');
    return this.http.get(url);
  }
  getWipeInstrument() {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.hp + '/api/instrument/search?cacheBuster=1640769961988&date=2021-12-29T03%253A49%253A32-05%253A00&searchAcrossDepts=true&usage=47');
    return super.fetch(url);
  }

  getManufacturers() {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.inventory + '/api/manufacturer/getAll');
    return super.fetch(url);
  }

  getTaskTypes() {
    const url = super.serviceUrl(this.apiConfig.hp + '/api/tasks/types');
    return super.fetch(url);
  }

  getPeriodTypes() {
    const url = super.serviceUrl(this.apiConfig.hp + '/api/periodtype');
    return super.fetch(url);
  }

  getUoms() {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.config + '/api/uom');
    return super.fetch(url);
  }
  getNuclides() {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.config + '/api/nuclide');
    return super.fetch(url);
  }
  //  getusersConfig(): Observable<any> {
  //   const request = {};
  //   const url = super.serviceUrl(this.apiConfig.util+'/api/userManagement/users?onlyActiveUsers=N');
  //   return this.http.get(url);
  // }
  getActiveUserList() {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.util + '/api/userManagement/users?onlyActiveUsers=Y');
    return super.fetch(url).pipe(map((res: IResponse) => {
      res.data.forEach(user => {
        user.fullName = user.lastName + ", " + user.firstName;
      });
      res.data = {
        activeUsers: res.data, defaultUser: {
          id: this.storage.retrieve(CacheConstant.SessionStorageData.LoggedInUserID),
          fullName: this.storage.retrieve(CacheConstant.SessionStorageData.LoggedInUser)
        }
      };
      return res;
    }));

  }





  deleteTask(data): Observable<any> {
    const request = {};
    const id = data;
    const url = super.serviceUrl(this.apiConfig.hp + '/api/tasks/' + id);
    return super.delete(url, {});
  }

  saveConfigTest(taskData: any) {

    const url = this.apiConfig.hp + '/api/tasks?';
    return super.post(url, taskData);

  }

  count() {
    return super.fetch(this.apiConfig.inventory + '/api/inventory/count');
  }

  searchInventories(criteria) {
    return super.fetch(this.apiConfig.inventory + '/api/inventory/searchall', { params: criteria })

  }

  getEssentialKitProdForm() {
    return super.fetch(this.apiConfig.inventory + '/api/inventory/essential/kit/prodform')
  }

  transferToAccount() {
    return super.fetch(this.apiConfig.patient + '/api/sharing');
  }

  moveToWaste() {
    return super.fetch(this.apiConfig.bin + '/api/bin/openedBins');
  }
  getOpenCardinalBins() {
    return super.fetch(this.apiConfig.bin + '/api/bin/searchbyvendor', { params: { vendor: 'Cardinal Health' } })

  }
  transformInventory(inventories) {
    let retVal = []
    inventories.forEach((inventory) => {
      retVal.push({ inventoryId: inventory.id, actQty: inventory.actQty, disposalDate: inventory.currentAmountDate })
    });
    return retVal;
  }
  moveToBin(selectedInventories, bin) {
    return super.put(this.apiConfig.bin + '/api/bin/' + bin + '/inventory', this.transformInventory(selectedInventories))

  }
  trace(rxNo) {
    return super.fetch(this.apiConfig.inventory + '/api/inventory/trace', { params: { rxOrLotNum: rxNo } });

  }
  sealSourceUsedInHp(inventories) {
    return super.post(this.apiConfig.inventory + '/api/inventory/sealedsources/configured', inventories)
  }

  deleteInventoryByIds(ids, force) {
    return super.patch(this.apiConfig.inventory + '/api/inventory/deleteAll?force=' + force, ids);

  }
  transformInventories(inventories) {
    var retVal = []
    inventories.forEach((inventory) => {
      retVal.push(inventory.id);
    });
    return retVal;
  }

  transferToAccountApi(id, selectedInventories) {
    return super.put(this.apiConfig.inventory + '/api/inventory/transferToAccount/' + id, this.transformInventories(selectedInventories))

  }

  validateReturn(inventories) {
    return super.post(this.apiConfig.inventory + '/api/inventory/return/validate', { inventories: inventories })
  }

  checkRx(date, rxNumbers, shipto) {
    return super.post(this.apiConfig.inventory + '/api/inventory/checkrx', { date: date, rxNumbers: rxNumbers, trgtShipToForTrnsfr: shipto })

  }

  tranformForRfc(inventories) {
    var retVal = [];
    inventories.forEach((inv) => {
      retVal.push({ inventoryId: inv.id });
    });
    return retVal;
  }

  returnForCredit(inventories, bin) {
    return super.put(this.apiConfig.bin + '/api/bin/' + bin.id + '/inventory/return', this.tranformForRfc(inventories))
  }
  getShipperDetails(shipTo) {
    return super.fetch(this.apiConfig.inventory + '/api/digirad/details', { params: { shipTo: shipTo } })
  }


  unPrepareKit(id) {
    return super.put(this.apiConfig.inventory + '/api/kit/unprepare/' + id, { referenceDate: moment().format() })
  }

  unPrepareKitForSplit(inventoryId) {
    return super.put(this.apiConfig.inventory + '/api/kit/unprepareSplit/' + inventoryId, { referenceDate: moment().format() })

  }

  saveQcValues(inventoryId, data) {
    return super.put(this.apiConfig.inventory + '/api/inventory/' + inventoryId + '/performQc', data)
  }

  unElute(inventoryId) {
    return super.put(this.apiConfig.inventory + '/api/inventory/unElute/' + inventoryId, null)
  }

  // transformForUpdate(inventory) {
  //   let updatedInv = {
  // radioActive: inventory.radioActive,
  // activityChanged: inventory.activityChanged,
  // actQty: inventory.activityChanged ? parseFloat(inventory.popoverActQty) : inventory.actQty,
  // amtQty: inventory.quantity ? parseFloat(inventory.quantity) : null,
  // volumeQty: inventory.popoverVolumeQty ? parseFloat(inventory.popoverVolumeQty) : -1,
  // source: inventory.source, overrideBy: inventory.overrideBy,
  // expiryDate : inventory.expiryDate
  //   };
  //   if (inventory.source) {
  //     updatedInv.sealedSource = { id: inventory.sealedSource.id,
  //       manufacturer: inventory.sealedSource.popoverManufacturer,
  //       modelNumber: inventory.sealedSource.popoverModelNumber
  //     }
  //     updatedInv.manufacturingLotNum = (inventory.sealedSource.popoverSerialNo) ? inventory.sealedSource.popoverSerialNo : 0;
  //     updatedInv.calibrationDate = moment().toAccountTZ(inventory.popoverCalDate);  //SB-4327
  //     updatedInv.calActivity = parseFloat(inventory.popoverCalActivity);
  //     if (inventory.popoverExpiryDate)
  //       updatedInv.expiryDate = moment().toAccountTZ(inventory.popoverExpiryDate); //SB-4327
  //   } else {
  //     updatedInv.expiryDate = moment(inventory.popoverExpiryDate);
  //     updatedInv.expiryDate = moment().toAccountTZ(inventory.popoverExpiryDate); //SB-4327
  //   }
  //   return updatedInv;
  // }

  update(id, data) {
    return super.put(this.apiConfig.inventory + '/api/inventory/' + id, data)
  }

  updateSealedSource(sealedSource, inventoryDetails) {
    return super.put(this.apiConfig.inventory + '/api/inventory/' + inventoryDetails.sealedSource.inventoryId + '/source/' + inventoryDetails.sealedSource.id, sealedSource)
  }

  getGenerators() {
    return super.fetch(this.apiConfig.inventory + '/api/elute/generators')
  }

  getUomsList() {
    return super.fetch(this.apiConfig.config + '/api/uom')
  }

  getDoseCalibrators(date, searchAcrossDepts) {
    return super.fetch(this.apiConfig.hp + '/api/instrument/search', { params: { usage: 41, date: moment(date).format(), searchAcrossDepts: searchAcrossDepts } })
  }

  getSurveyInstruments(date, searchAcrossDepts) {

    return super.fetch(this.apiConfig.hp + '/api/instrument/search', {
      params: {
        date: date,
        searchAcrossDepts: searchAcrossDepts, usage: 46
      }
    })
  }

  getWipeInstruments(date, searchAcrossDepts) {
    return super.fetch(this.apiConfig.hp + '/api/instrument/search', {
      params: {
        date: date,
        searchAcrossDepts: searchAcrossDepts, usage: 47
      }
    })
  }

  getWaste() {
    return super.fetch(this.apiConfig.bin + '/api/waste');
  }

  getSources(searchAcrossDepts) {
    return super.fetch(this.apiConfig.inventory + '/api/inventory/source', { params: { searchAcrossDepts: searchAcrossDepts } })
  }

  generateDotShipper(dotShipper) {
    return super.post(this.apiConfig.inventory + '/api/shipper/save', dotShipper, {
      responseType: 'arraybuffer'
    })

  }
  findByColdKit(coldKitId) {
    return super.fetch(this.apiConfig.inventory + '/api/inventory/kit/search', { params: { inventoryId: coldKitId } })
  }

  save(data) {
    return super.post(this.apiConfig.inventory + "/api/elute", data)
  }
  getByProduct(prodFormId) {
    return super.fetch(this.apiConfig.inventory + "/api/product/" + prodFormId + "/kit")
  }
  getOtherProducts() {
    return super.fetch(this.apiConfig.inventory + '/api/otherproduct/getAll')
  }
  findRadioactiveInventories(kitConfigurationId) {
    return super.fetch(this.apiConfig.inventory + '/api/inventory/search', { params: { kitConfigId: kitConfigurationId } })

  }
  saveKitPrep(kit) {
    return super.post(this.apiConfig.inventory + '/api/kit/preparation', kit);
  }

  getQcData(prodFormNum,invId){
    return super.fetch(this.apiConfig.inventory+'/api/kit/qctemplate/'+prodFormNum, { params: { inventoryId: invId } });
  }

  saveQcData(data){
    return super.post(this.apiConfig.inventory+'/api/qctest/save',data);
  };

  deleteQCData(qcCombinationResultNum) {
    return super.put(this.apiConfig.inventory+'/api/qctest/remove' + '/'+ qcCombinationResultNum,qcCombinationResultNum);
  }

  checkDupRxShipment(req){
    return super.post(this.apiConfig.inventory+'/api/inventory/checkrx',req);
  }

  findAssociatedInventory(rxNum, lotNum, productFormNum){
    if(rxNum && lotNum){
      return super.fetch(this.apiConfig.inventory+'/api/inventory/search/association', { params: { rxNum: rxNum, lotNum: lotNum, productFormNum: productFormNum }});
    }else if(!rxNum && lotNum){
      return super.fetch(this.apiConfig.inventory+'/api/inventory/search/association', { params: { lotNum: lotNum, productFormNum: productFormNum }});
    }else{
      return super.fetch(this.apiConfig.inventory+'/api/inventory/search/association', { params: { rxNum: rxNum, productFormNum: productFormNum }});
    }

  }

  getModifyyItemsList(inventoryDetails, nuctracEssential) {
    return [{
      'key': 'trace',
      'value': 'Trace',
      'disabled': false
    },
    {
      'key': 'printlabel',
      'value': 'Print Label',
      'disabled': false
    },
    {
      'key': 'preparekit',
      'value': 'Prepare Kit',
      'disabled': !inventoryDetails.product.radioActive ? false : true
    },
    {
      'key': 'unprepare',
      'value': 'Unprepare',
      'disabled': (inventoryDetails.allowUnPrepare || inventoryDetails.allowUnprepareForSplit) ? false : true
    },
    {
      'key': 'unelute',
      'value': 'Unelute',
      'disabled': inventoryDetails.elute ? false : true
    },
    {
      'key': 'performqc',
      'value': 'Perform QC',
      'disabled': (!(this.cache.get(CacheConstant.LocalStorage.NuctracEssentials)) && inventoryDetails.product.radioActive) ? false : true
    },
    {
      'key': 'edit',
      'value': 'Edit',
      'disabled': false
    },
    {
      'key': 'delete',
      'value': 'Delete',
      'disabled': false
    }
    ];
  }
}


